import React, {useState, useContext} from 'react';
import { Header } from '.';
import { useNavigate } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { DashboardMenu, NavigationBar } from '../components';
import { SiteContext } from '../context';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    contitle: Yup.string()
      .label('Title')
      .required()
      .min(4, 'Must have at least 4 characters'),
    conabout: Yup.string()
      .label('About')
      .required(),
    conamount: Yup.string()
      .label('Amount')
      .required(),
    constatus: Yup.string()
      .label('Status')
      .required(),
  });

const ContributionAdd = () => {

    let navigate = useNavigate();

const { apiUrl } = useContext(SiteContext);

const userData = JSON.parse(localStorage.getItem('user'));

const [uploadedPic, setUploadedPic] =  useState(null);
const [msg, setMsg] = useState('');
const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = (values, { setSubmitting, resetForm, setShowModal, selectedPackage, selectedUser }) => {

    let formData = new FormData();

    formData.append('contitle', values.contitle);
    formData.append('conabout', values.conabout);
    formData.append('conamount', values.conamount);
    formData.append('constatus', values.constatus);
    formData.append('conorgref', values.conorgref);
    formData.append('conusername', userData.conusername);
    formData.append('role', userData.role);
    formData.append('action', 'create');
  
      return fetch(`${apiUrl}/api/contributions.php`, {
        method: 'post',
        body: formData
      })
          .then((res) => res.json())
        .then(async (res) => {

          console.log(res);
  
          if(res.status === 200) {
              resetForm({});
              setSubmitting(false);
              setMsg(res.msg);
              setTimeout(() => {
                setMsg('');
              }, 3000);
              setTimeout(() => {
                navigate('/contributions');
            }, 3000);
          } else if(res.status === 400) {
            setErrorMsg(res.msg);
            setTimeout(() => {
              setErrorMsg('');
            }, 5000);
            setSubmitting(false);
          } else {
            alert(
                  'Contribution submission failed',
                  'Error connection to the server please check your details and try again',
                  [{ text: 'Okay' }]
                );
          }
        })
        .catch((error) => {
          console.log('Api call error', error.message);
        });
    };
    
    
  const slugify = (string) => {
    return string
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }

    return (
        <div>
            <Header />
            <div>
                <div className='row'>
                    <div className='col-md-2 bg-light'>
                        <DashboardMenu />
                    </div>
                    <div className='col-md-10'>
                    <div className='container my-2'>

                    <NavigationBar section={'Contributions'} goback={true} />

                <h3>Contribution Manage</h3>
                <div className='my-2 d-flex justify-content-between'>
                  <div className='align-items-center'>
                  {msg !== '' ? <div className='p-2'><span className='p-2 border border-info text-dark'>{msg}</span></div> : null}
                {errorMsg !== '' ? <div className='p-2'><span className='p-2 border border-info text-dark'>{errorMsg}</span></div> : null}
                  </div>
                </div>

                <Formik
                    initialValues={{
                      conid: '',
                      contitle: '',
                      conabout: '',
                      conamount: '',
                      constatus: '',
                      conorgref: '',
                      conusername: userData.conusername,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      handleSubmit(values, { setSubmitting, resetForm });
                    }}
                  >
                    {({
                      handleChange,
                      values,
                      handleSubmit,
                      errors,
                      isValid,
                      isSubmitting,
                      handleBlur,
                      touched,
                      setFieldValue
                    }) => (
                      <div>
                      <form onSubmit={handleSubmit} encype="multipart/form-data">
                        <div className='row my-2'>
                          <div className='col-md-8'>

                            <div className='form-group my-2'>
                            <div>
                              <label htmlFor="contitle">Title</label>
                            </div>
                            <Field
                              id="contitle"
                              name="contitle"
                              value={values.contitle}
                              onChangeText={handleChange('contitle')}
                              placeholder="Title"
                              placeholderTextColor="#999"
                              onBlur={handleBlur('contitle')}
                              autoCapitalize="none"
                              style={{
                                padding: 4,
                            }}
                            className="form-control"
                            />
                            {touched.contitle && errors.contitle && <div className='py-1'>
                                  <span className='text-danger'>{touched.contitle && errors.contitle}</span>
                            </div>}
                          </div>


                        <div className='form-group my-1'>
                          <div>
                            <label htmlFor="conabout">Story</label>
                          </div>
                            <Field
                              as='textarea'
                              id="conabout"
                              name="conabout"
                              value={values.conabout}
                              onChangeText={handleChange('conabout')}
                              placeholder="Story"
                              placeholderTextColor="#999"
                              onBlur={handleBlur('conabout')}
                              autoCapitalize="none"
                              style={{
                                padding: 4
                            }}
                            rows='3'
                            className="form-control"
                            />
                          {touched.conabout && errors.conabout && <div className='py-1'>
                                <span className='text-danger'>{touched.conabout && errors.conabout}</span>
                          </div>}
                        </div>

                          </div>
                          <div className='col-md-4'>

                          <div className='form-group my-3'>
                            <div>
                              <label htmlFor="conamount">Title</label>
                            </div>
                            <Field
                              id="conamount"
                              name="conamount"
                              value={values.conamount}
                              onChangeText={handleChange('conamount')}
                              placeholder="Title"
                              placeholderTextColor="#999"
                              onBlur={handleBlur('conamount')}
                              autoCapitalize="none"
                              style={{
                                padding: 4,
                            }}
                            className="form-control"
                            />
                            {touched.conamount && errors.conamount && <div className='py-1'>
                                  <span className='text-danger'>{touched.conamount && errors.conamount}</span>
                            </div>}
                          </div>

                          <div className='form-group my-1'>
                          <div>
                            <label htmlFor="constatus">Status</label>
                          </div>
                            <Field
                              as="select"
                              id="constatus"
                              name="constatus"
                              value={values.constatus}
                              onChangeText={handleChange('constatus')}
                              placeholder="Status"
                              placeholderTextColor="#999"
                              onBlur={handleBlur('constatus')}
                              autoCapitalize="none"
                              style={{
                                padding: 4
                            }}
                            className="form-control"
                            >
                              <option value="">Select...</option>
                              <option value="Active">Active</option>
                              <option value="Inactive">Inactive</option>
                            </Field>

                          {touched.constatus && errors.constatus && <div className='py-1'>
                                <span className='text-danger'>{touched.constatus && errors.constatus}</span>
                          </div>}
                        </div>

                          </div>
                        </div>
                        <button
                            type='submit'
                            buttonType="outline"
                            onClick={handleSubmit}
                            title="Submit"
                            disabled={!isValid || isSubmitting}
                            loading={isSubmitting}
                            className='btn btn-primary'
                          >
                              Submit
                          </button>
                        
                        </form>
                        </div>
                    )}
                  </Formik>
                              </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ContributionAdd;